
import { useCallback } from "react";
import { useSession } from "@/hooks/useSession";
import { useProfile } from "@/hooks/useProfile";
import { supabase } from "@/integrations/supabase/client";
import { format } from "date-fns";
import { useToast } from "@/hooks/use-toast";

export function useCertificateDownload() {
  const { session } = useSession();
  const { data: profile } = useProfile(session?.user?.id);
  const { toast } = useToast();

  const handleDownloadCertificate = useCallback(async (resourceId: string, topic: string, completedAt: string | null) => {
    if (!session?.user?.id || !profile) return;

    try {
      const completionDate = completedAt 
        ? format(new Date(completedAt), 'MMMM d, yyyy')
        : format(new Date(), 'MMMM d, yyyy');
      
      let traineeName = '';
      
      if (profile.first_name && profile.last_name) {
        traineeName = `${profile.first_name} ${profile.last_name}`;
      } else if (profile.first_name) {
        traineeName = profile.first_name;
      } else if (profile.last_name) {
        traineeName = profile.last_name;
      } else {
        traineeName = profile.email;
      }
      
      console.log('Certificate download for user:', {
        userId: session.user.id,
        name: traineeName,
        profile: profile
      });
      
      const { data, error } = await supabase.functions.invoke('generate-certificate', {
        body: {
          resourceId,
          traineeName,
          topic,
          completionDate,
        },
      });

      if (error) throw error;

      window.open(data.certificateUrl, '_blank');
    } catch (error) {
      console.error('Error downloading certificate:', error);
      toast({
        title: "Error",
        description: "Failed to download certificate. Please try again.",
        variant: "destructive",
      });
    }
  }, [session?.user?.id, profile, toast]);

  return { handleDownloadCertificate };
}
